module.exports = __webpack_public_path__ + "img/tobias_run_side_low.63ce38a9.jpg";